const getFaviconType = (favicon) => {
  const path = favicon.split("?")[0].toLowerCase();

  if (path.endsWith(".svg")) {
    return "image/svg+xml";
  }

  if (path.endsWith(".ico")) {
    return "image/x-icon";
  }

  return "image/png";
};

const replaceIconLink = ({ rel, href, type, sizes }) => {
  document
    .querySelectorAll(`link[rel="${rel}"]`)
    .forEach((existingLink) => existingLink.remove());

  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  link.type = type;

  if (sizes) {
    link.setAttribute("sizes", sizes);
  }

  document.head.appendChild(link);
};

export const applyTenantDocumentBranding = (tenant) => {
  if (!tenant || typeof document === "undefined") {
    return;
  }

  if (tenant.title) {
    document.title = tenant.title;
  }

  const favicon = tenant.favicon || tenant.logo;
  if (!favicon) {
    return;
  }

  const separator = favicon.includes("?") ? "&" : "?";
  const faviconHref = `${favicon}${separator}tenant=${encodeURIComponent(
    tenant.cssName || "default"
  )}&v=${encodeURIComponent(tenant.faviconVersion || "1")}`;
  const faviconType = getFaviconType(favicon);
  const iconSizes = faviconType === "image/svg+xml" ? "any" : "192x192";

  // Recreate every browser icon link so a cached fallback from index.html or
  // another tenant cannot win after a hard refresh.
  replaceIconLink({
    rel: "icon",
    href: faviconHref,
    type: faviconType,
    sizes: iconSizes,
  });
  replaceIconLink({
    rel: "shortcut icon",
    href: faviconHref,
    type: faviconType,
    sizes: iconSizes,
  });
  replaceIconLink({
    rel: "apple-touch-icon",
    href: faviconHref,
    type: faviconType,
    sizes: "192x192",
  });
};
